import {useUserStore} from '@/store/user'
import {useAuthStore} from '@/store/auth'

export default defineNuxtRouteMiddleware((to, from) => {
  if (!process.client || !to.query.customerUuid) {
    return
  }

  const app = useNuxtApp()
  const authStore = useAuthStore()
  const userStore = useUserStore()

  if (from.fullPath.includes('/auth#state=') || userStore.customerUuidLink === '') {
    const newQuery = {...to.query}
    delete newQuery.customerUuid
    return navigateTo({path: to.path, query: newQuery, hash: to.hash})
  }

  if (!app.$auth.loggedIn && authStore.isTokenExpired) {
    const newQuery = {...to.query}
    delete newQuery.customerUuid
    return navigateTo('/auth/login')
  }
})
